export function showIntercom(show: boolean) {
  const intercomElement = getIntercomElement();

  if (intercomElement && intercomElement instanceof HTMLElement) {
    intercomElement.style.display = show ? '' : 'none';
  }
}

function getIntercomElement() {
  return (
    document.getElementById('intercom-container') || document.getElementsByClassName('intercom-lightweight-app')[0]
  );
}

declare global {
  interface Window {
    Intercom?: Function;
  }
}

export async function updateIntercom(attributes: Record<string, string>) {
  const { Intercom } = window;
  Intercom && Intercom('update', attributes);
}
